import { useMutation, useQueryClient } from "@tanstack/react-query";
import { QUERY_KEYS } from "../../../constants/queryKeys";
import { updateReleaseTrackOrder } from "../releaseAPI";
import { updatePlayListOrder } from "../../../store/actions/abPlayerStore";
import { convertArtistReleaseToPlaylistTrack } from "../../../store/models/playListTrack";
import { useAppDispatch } from "../../../store/hooks";
import { toast } from "react-toastify";

interface UpdateTrackOrderArgs {
  releaseId: number;
  updatedTrackOrder: number[];
}

export const useTrackOrderUpdateMutation = () => {
  const queryClient = useQueryClient();
  const dispatch = useAppDispatch();

  return useMutation({
    mutationFn: async ({
      releaseId,
      updatedTrackOrder,
    }: UpdateTrackOrderArgs) => {
      return await updateReleaseTrackOrder(releaseId, updatedTrackOrder);
    },
    mutationKey: [QUERY_KEYS.UPDATE_RELEASE_TRACK_ORDER],
    onSuccess: (
      { tracks, error_occurred },
      { releaseId }: UpdateTrackOrderArgs,
    ) => {
      if (error_occurred) {
        toast.error("An error occurred updating the track order.");
      }
      // footer player lives in redux so we still need to update the store
      dispatch(
        updatePlayListOrder({
          playlist: convertArtistReleaseToPlaylistTrack(tracks),
        }),
      );

      void queryClient.setQueryData(
        [QUERY_KEYS.FETCH_ARTIST_RELEASE_TRACKS, releaseId],
        tracks,
      );
    },
  });
};
